import PropTypes from 'prop-types';
import { OfferRow } from './OfferRow';

import styles from './FLightHitContent.scss';

const getOfferByType = (offers, type) => offers.find((o) => o.type === type);

export const FLightHitContent = (props) => {
  const {
    offers,
    specHotelLabel,
    unspecHotelLabel,
    flightOnlyLabel,
    specHotelInfo,
    orderBy,
    onBuildUpsellUrl,
    isLoading,
  } = props;

  const specified = { offer: getOfferByType(offers, 'specified'), label: specHotelLabel, info: specHotelInfo.toLowerCase() };
  const unspecified = { offer: getOfferByType(offers, 'unspecified'), label: unspecHotelLabel };
  const flightOnly = { offer: getOfferByType(offers, 'flightOnly'), label: flightOnlyLabel };

  // default order
  let entries = [specified, unspecified, flightOnly];

  if (orderBy === 'PRICE') {
    // cheapest first
    entries = entries.reverse();
  }

  if (isLoading) {
    entries = entries.slice(0, 1);
  }

  const rows = entries.map((entry) => {
    if (entry.offer) {
      return (
        <OfferRow
          key={entry.offer.tripId}
          price={entry.offer.priceFormatted}
          label={entry.label}
          info={entry.info}
          href={onBuildUpsellUrl(entry.offer)}
          isLoading={isLoading}
        />
      );
    }
    return null;
  }).filter(Boolean);

  return <div className={styles.root}>{rows}</div>;
};

FLightHitContent.propTypes = {
  specHotelLabel: PropTypes.node,
  unspecHotelLabel: PropTypes.node,
  flightOnlyLabel: PropTypes.node,
  specHotelInfo: PropTypes.node,
  offers: PropTypes.array,
  orderBy: PropTypes.string,
  onBuildUpsellUrl: PropTypes.func,
  isLoading: PropTypes.bool,
};
